// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/messaging";
import "firebase/storage";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";



// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCIMrJD1lDIeiHDqjRfGiPCzDhYnaQSSi0",
  authDomain: "emprende-257501.firebaseapp.com",
  databaseURL: "https://emprende-257501.firebaseio.com",
  projectId: "emprende-257501",
  storageBucket: "emprende-257501.appspot.com",
  messagingSenderId: "423805886578",
  appId: "1:423805886578:web:abf32e96f74da5195aa2eb",
  measurementId: "G-H39LBSTT3X",
};


firebase.initializeApp(firebaseConfig);
if (location.hostname === "localhost") {
  firebase.auth().useEmulator("http://localhost:9099/");
  firebase.firestore().useEmulator("localhost", 8080);
  firebase.functions().useEmulator('localhost', 5001);
  firebase.storage().useEmulator('localhost', 9199);
}
firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user) => {
      resolve(user);
    }, reject);
  });
};

const messaging = firebase.messaging();
// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.

// messaging.getToken(messaging, { vapidKey: applicationServerPublicKey }).then((currentToken) => {
//   if (currentToken) {
//     // Send the token to your server and update the UI if necessary
//     // ...
//     console.log('cureentToken', currentToken)
//   } else {
//     // Show permission request UI
//     console.log('No registration token available. Request permission to generate one.');
//     // ...
//   }
// }).catch((err) => {
//   console.log('An error occurred while retrieving token. ', err);
//   // ...
// });

// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker
//   `messaging.onBackgroundMessage` handler.
messaging.onMessage((payload) => {
  console.log('Message received. ', payload);
  // let data = payload.data;
  // const notify = new Notification(data.t, { body: data.b, icon: 'favicon.ico' })
  // notify.onclick = function () {
  //   window.location.href = data.link
  // }
  // ...
});


var db = firebase.firestore();
window.DB = db;
let coll_vehicles = db.collection("recursos").doc("vehiculos");
coll_vehicles.get().then((doc) => {
  if (!doc.exists) console.log("No hay vehivulos cargados.");
  let vehiculos = window.vehiculos = doc.data();

  window.localStorage.setItem("vehiculos", JSON.stringify(vehiculos));
});

document.addEventListener("DOMContentLoaded", () => {
  fetch("https://emprende.soltarimpresores.com/api/shipvia").then((res) => {
    res.json().then((shipvias) => {
      window.shipvias = shipvias;
      document.dispatchEvent(new CustomEvent("shipvias", { detail: shipvias }));
      window.localStorage.setItem("shipvias", JSON.stringify(shipvias));
    });
  });
  fetch("https://emprende.soltarimpresores.com/api/inventory").then((res) => {
    res.json().then((almacenes) => {
      window.almacenes = almacenes;
      window.localStorage.setItem("almacenes", JSON.stringify(almacenes));
    });
  });
  firebase.auth().onAuthStateChanged((user) => {
    if (user) window.user = user;
  });
});

createApp(App)
  .use(router)
  .mount("#app");

if ("serviceWorker" in navigator) {
  console.log("CLIENT: service worker registration in progress.");
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js');
  });

} else {
  console.log("CLIENT: service worker is not supported.");
}
